<template>
    <div class="footer">
        <transition name="footer__share">
            <div class="footer__share">
                <div class="share"></div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        mounted(){
            nc.promokit.share.init();
        }
    };
</script>

<style lang="scss">
    .footer {
        @include position-abs($width:100%, $height:132px, $left:0, $bottom:0px);
        @include bg($bg:"img/footer_bg.png", $position:0 0); z-index:10;
        background-repeat: repeat-x;
        &__share {
            position: absolute;
            left: 50%;
            bottom: 30px;
            transform: translateX(-50%);
            width: 262px;
            height: 11px;
            padding-right: 40px;
            z-index: 10;
            @include bg($bg:"img/copyright.png", $position:0 0); z-index:10;

            &-enter-active {
                animation-name: fadeIn;
                animation-duration: 2s;
                animation-fill-mode: backwards;
            }
        }
    }

    .share {
        position: absolute;
        right: 0;
        bottom: -10px;
    }
</style>
